<template>
  <div class="displayNoneVuePagination">
    <v-client-table :data="sortLiaisonsTarif"
                    class='mgt-10px column is-12 is-paddingless'
                    :columns="columns"
                    :options="options">
    </v-client-table>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';

export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  computed: {
    columns() {
      return ['produitEnfant.libelle', 'produitEnfant.reference'];
    },
    sortLiaisonsTarif() {
      return cloneDeep(this.data.liaisonsTarif);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          'produitEnfant.reference': this.$i18n.t('addProduitsAssocies.tab.ref'),
          'produitEnfant.libelle': this.$i18n.t('addProduitsAssocies.tab.libelle'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: texts,
        sortable: ['produitEnfant.reference', 'produitEnfant.libelle'],
        columnsClasses: {
          'produitEnfant.libelle': 'width-535',
        },
      };
    },
  },
};

</script>
